/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExternalType {
    HCR_ORGANIZATION = 'hcr_organization',
}
